module.exports = __webpack_public_path__ + "static/img/ksrk_logo2.4009fb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/官网首页/firstlink/ksrk_logo2.png
// module id = 4JYD
// module chunks = 1